import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  funds: [],
  campaigns: [],
  language: null,
  timezone: null,
  startDate: null,
  endDate: null,
  hourOfDonation: null,
  interval: null,
  tip: 0,
  userInfo: {
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    unitNumber: "",
    postalCode: "",
    selectedRegion: "",
    selectedCountry: "GB"
  }
};

const donationSlice = createSlice({
  name: 'donation',
  initialState,
  reducers: {
    setFunds: (state, action) => {
      state.funds = action.payload;
    },
    setCampaigns: (state, action) => {
      state.campaigns = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setTimezone: (state, action) => {
      state.timezone = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setHourOfDonation: (state, action) => {
      state.hourOfDonation = action.payload;
    },
    setInterval: (state, action) => {
      state.interval = action.payload;
    },
    setTip: (state, action) => {
      state.tip = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = {
        ...state.userInfo,
        ...action.payload
      };
    }
  },
});

export const {
  setFunds,
  setCampaigns,
  setLanguage,
  setTimezone,
  setStartDate,
  setEndDate,
  setHourOfDonation,
  setInterval,
  setTip,
  setUserInfo
} = donationSlice.actions;

export default donationSlice.reducer;
